import styled from "styled-components";
import { position, layout, flexbox, space } from "styled-system";

import { hexToRGBA } from "util/colorUtility";

export const OuterContainer = styled.div`
  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    background-color: ${() => hexToRGBA("#000000", 0.8)};
    height: 100vh;
    display: flex;

    align-items: center;
    justify-content: center;
  }

  ${position}
  ${layout}
`;

export const Container = styled.div`
  position: relative;
  height: 100%;

  opacity: 1;
  background-color: #fbfbfb;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  &:focus {
    outline: none;
  }

  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    width: 90%;
    height: 95%;
    border-radius: 1vw;
    overflow: hidden;

    padding: 28px 44px 0;
  }
`;

export const ControlsRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${(props) => (props.dataList ? "12px" : "6vh")};
`;

export const Text = styled.p`
  font-size: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  padding: 0 10px;
  text-align: center;
  ${layout}
`;

export const IconBox = styled.div`
  background-color: #000000;
  opacity: 80%;
  padding: 10px;
  border-radius: 5px;
  display: flex;

  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    padding: 8px;
  }

  ${flexbox}
  ${space}
  ${layout}
`;

export const Slider = styled.input`
  -webkit-appearance: none;
  -moz-apperance: none;
  appearance: none;
  height: 4px;
  border-radius: 4px;
  padding: 0;
  background-color: ${(props) => props.theme.colors.white};
  cursor: pointer;

  &::-webkit-slider-thumb {
    -webkit-appearance: none !important;
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 50%;
    height: 14px;
    width: 14px;
  }
`;
